import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ef-line" }
const _hoisted_2 = { class: "ef-line" }
const _hoisted_3 = { class: "ef-subscriptions__search" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)

import {computed, ComputedRef, onMounted, ref} from "vue";
import {TABLE_ITEMS} from '@/constants/index.ts';
import {storeUser} from "@/stores/user";
import User from "@/types/User";
import Header from '@/components/Header.vue';
import Input from '@/components/Input.vue';
import Table from '@/components/Table.vue';
import CreateUser from '@/modales/CreateUser.vue';
import EditUser from '@/modales/EditUser.vue';
import Confirm from '@/modales/Confirm.vue';
import Subscribe from '@/modales/Subscribe.vue';

import {storeSystem} from "@/stores/system";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const users = ref<Array<any>>([]);

const searchTerm = ref('');
const usersToDisplay: ComputedRef<Array<any>> = computed(() => {
  if (users.value.length === 0) {
    return [{ id: "0", bubble: 'test', fields: [{title: 'title', value: 'value'}, {title: 'title', value: 'value'}, {title: 'title', value: 'value'}, {title: 'title', value: 'value'}], actions: [{ icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' }]}];
  } else {
    let result = users.value;
    //FILTER
    if (searchTerm.value !== '') result = result.filter((user: any) => user.lastname.includes(searchTerm.value));
    //BUILD ITEM_TABLE
    return result.map((item) => {
      let actions = [
        { icon: 'fa-solid fa-eye', text: 'Voir', action: 'view' },
        { icon: 'fa-solid fa-square-up-right', text: 'Inscrire à une formation', action: 'subscribe', multiple: true },
        { icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' },
        { icon: 'fa-solid fa-trash', text: 'Supprimer', action: 'remove', multiple: true },
      ];
      const fields = [
        { title: 'Prénom', value: item.firstname },
        { title: 'Nom', value: item.lastname  },
        { title: 'E-mail', value: item.email  },
        { title: 'Entreprise', value: item.companyName  },
      ]
      return { id: item.id, bubble: item.firstname[0]+item.lastname[0], fields: fields, actions: actions };
    });
  }
});

const confirmAction = ref('');

const msgConfirm = ref('');
const showConfirm = ref(false);

const closeConfirm = () => {
  showConfirm.value = false;
};

const _storeSystem = storeSystem();

const validConfirm = () => {
  showConfirm.value = false;
  switch (confirmAction.value) {
    case 'remove':
      loading.value = true;
      _storeUser.removeCollab(userToEdit.value.id).then(() => {
        _storeSystem.addInfoTag({ id: '', type: 'success', text: 'Utilisateur supprimé' });
        loadUser();
      });
      break;
    case 'remove-multiple':
      loading.value = true;
      let tick = 0;
      usersId.value.forEach((userId) => {
        tick++;
        _storeUser.removeCollab(userId).then(() => {
          _storeSystem.addInfoTag({ id: '', type: 'success', text: 'Utilisateur supprimé' });
          if (tick === usersId.value.length) loadUser();
        });
      });
      break;
  }
};

const removeUser = (userId: string) => {
  confirmAction.value = 'remove';
  userToEdit.value = {...users.value.find((user) => user.id === userId)};
  msgConfirm.value = `supprimer l'utilisateur ${userToEdit.value.firstname} ${userToEdit.value.lastname}`;
  showConfirm.value = true;
}

const usersId = ref<Array<string>>([]);
const removeUsers = (usersIdToRemove: Array<string>) => {
  usersId.value = usersIdToRemove;
  confirmAction.value = 'remove-multiple';
  msgConfirm.value = `supprimer ces utilisateurs`;
  showConfirm.value = true;
}

const headerActions = [
  { icon: 'fa-solid fa-user-plus', text: 'Créer un collaborateur', action: 'add' }
];

const userToEdit = ref<User>({
  company: '',
  role: '',
  email: '',
  firstname: '',
  id: '',
  lastname: '',
  groupId: '',
  groupName: '',
  preferences: null,
});

const usersToSubscribe = ref<Array<string>>([]);

const showCreateUser = ref(false);

const createUser = () => {
  showCreateUser.value = true;
}

const showEditUser = ref(false);

const closeCreateUser = () => {
  showCreateUser.value = false;
}

const closeEditUser = () => {
  showEditUser.value = false;
}

const editUserSuccess = () => {
  showEditUser.value = false;
  loadUser();
}

const editUser = (userId: string) => {
  userToEdit.value = {...users.value.find((user) => user.id === userId)};
  showEditUser.value = true;
}

const showSubscribe = ref(false);

const closeSubscribe = () => {
  showSubscribe.value = false;
}

const subscribe = (userId: string) => {
  usersToSubscribe.value = [userId];
  showSubscribe.value = true;
}

const _storeUser = storeUser();
const range = ref(0);

const nextRange = () => {
  range.value = range.value + 1;
  _storeUser.getAllUsers(((range.value+1) * TABLE_ITEMS), (range.value+2) * TABLE_ITEMS).then((response) => {
    users.value.push(...response);
  })
};

const myRef = ref(null);
const previousRange = () => {
  let content:HTMLElement = myRef.value!;
  let curScrollPos = content.scrollTop;
  let oldScroll = content.scrollHeight - content.clientHeight;
  range.value = range.value - 1;
  users.value.splice(TABLE_ITEMS,TABLE_ITEMS);
  _storeUser.getAllUsers(((range.value+1) * TABLE_ITEMS), (range.value+2) * TABLE_ITEMS).then((response) => {
    users.value.unshift(...response);
  })
  let newScroll = content.scrollHeight - content.clientHeight;
  content.scrollTop = curScrollPos + (newScroll - oldScroll);
};

const loading = ref(true);

const loadUser = () => {
  loading.value = true;
  _storeUser.getAllUsers(0,TABLE_ITEMS*2).then((response) => {
    users.value = response;
    loading.value = false;
  });
}

onMounted(() => {
  loadUser();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "ef-subscriptions",
      ref_key: "myRef",
      ref: myRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, {
          icone: "fa-solid fa-users",
          title: "Collaborateurs",
          actions: headerActions,
          onAdd: _cache[0] || (_cache[0] = ($event: any) => (createUser()))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(Input, {
            type: "text",
            placeholder: "Rechercher un collaborateur ...",
            modelValue: searchTerm.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchTerm).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(Table, {
        items: _unref(usersToDisplay),
        loading: loading.value,
        selectable: "",
        onEdit: _cache[2] || (_cache[2] = ($event: any) => (editUser($event))),
        onSubscribe: _cache[3] || (_cache[3] = ($event: any) => (subscribe($event))),
        onMultipleSubscribe: _cache[4] || (_cache[4] = () => {}),
        onRemove: _cache[5] || (_cache[5] = ($event: any) => (removeUser($event))),
        onMultipleRemove: _cache[6] || (_cache[6] = ($event: any) => (removeUsers($event))),
        onView: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push(`/users/${$event}`)))
      }, null, 8, ["items", "loading"])
    ], 512),
    _createVNode(CreateUser, {
      open: showCreateUser.value,
      onClose: closeCreateUser
    }, null, 8, ["open"]),
    _createVNode(EditUser, {
      open: showEditUser.value,
      userToEdit: userToEdit.value,
      onClose: closeEditUser,
      onEdit: editUserSuccess
    }, null, 8, ["open", "userToEdit"]),
    _createVNode(Subscribe, {
      open: showSubscribe.value,
      usersToSubscribe: usersToSubscribe.value,
      onClose: closeSubscribe
    }, null, 8, ["open", "usersToSubscribe"]),
    _createVNode(Confirm, {
      open: showConfirm.value,
      msg: msgConfirm.value,
      onClose: closeConfirm,
      onValid: validConfirm
    }, null, 8, ["open", "msg"])
  ], 64))
}
}

})